import { Avatar, Flex, Text } from '@chakra-ui/react';
import React from 'react';

export type SocialFeedbackItemProps = {
  id: string;
  avatar: string;
  name: string;
  occupation: string;
  quote: string;
};

const SocialFeedbackItem = ({
  occupation,
  name,
  quote,
  avatar,
}: SocialFeedbackItemProps) => (
  <Flex
    justify="space-between"
    direction="column"
    borderRadius="5xl"
    w={[`full`, null, `md`, `xl`]}
    minH="sm"
    boxShadow="0 3px 20px 0 rgba(0, 0, 0, 0.1)"
    px="10"
    mx={[null, null, 10]}
    py="9"
    my="4"
  >
    <Text fontSize="lg">{quote}</Text>
    <Flex direction="row" align="center" justify="start">
      <Avatar size="lg" name={name} src={avatar} me={5} />
      <Text>
        {name}, <strong>{occupation}</strong>
      </Text>
    </Flex>
  </Flex>
);

export default SocialFeedbackItem;
